// ===== Global context menu (right-click) with nested submenus =====
import { useEffect, useState } from "react";
import { useStore, setUI, getState } from "./store";
import { I } from "./Icons";

export const openMenu = (e, items) => {
  e.preventDefault();
  e.stopPropagation();
  setUI({ menu: { x: e.clientX, y: e.clientY, items } });
};
export const closeMenu = () => setUI({ menu: null });

const REG = {};
export const MenuList = ({ items, style, onDone, testId }) => {
  const [sub, setSub] = useState(null);
  return (
    <div className="mt-menu" style={style} data-testid={testId} onMouseDown={(e) => e.stopPropagation()}>
      {items.map((it, i) =>
        it.sep ? <div key={i} className="mt-menu-sep" /> : (
          <div
            key={i}
            className={`mt-menu-item ${it.disabled ? "disabled" : ""} ${sub === i ? "open" : ""}`}
            data-testid={`menu-item-${String(it.label).toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            onMouseEnter={() => setSub(it.items ? i : null)}
            onClick={() => { if (it.disabled || it.items) return; it.onClick && it.onClick(); onDone(); }}
          >
            <span className="mt-menu-check">{it.checked ? "✓" : it.icon ? it.icon : ""}</span>
            <span className="mt-menu-label">{it.label}</span>
            <span className="mt-menu-key">{it.shortcut || ""}</span>
            <span className="mt-menu-arrow">{it.items ? <I.arrowRight /> : ""}</span>
            {it.items && sub === i && <REG.List items={it.items} style={{ position: "absolute", left: "100%", top: -3 }} onDone={onDone} />}
          </div>
        )
      )}
    </div>
  );
};

REG.List = MenuList;

export default function ContextMenu() {
  const { menu } = useStore();
  useEffect(() => {
    const h = () => getState().menu && closeMenu();
    const k = (e) => e.key === "Escape" && closeMenu();
    window.addEventListener("mousedown", h);
    window.addEventListener("keydown", k);
    return () => { window.removeEventListener("mousedown", h); window.removeEventListener("keydown", k); };
  }, []);
  if (!menu) return null;
  const x = Math.min(menu.x, window.innerWidth - 240);
  const y = Math.min(menu.y, window.innerHeight - menu.items.length * 22 - 10);
  return <MenuList items={menu.items} style={{ position: "fixed", left: x, top: Math.max(0, y), zIndex: 1000 }} onDone={closeMenu} testId="context-menu" />;
}

